// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"input-field_checkbox__2dY2v"};